import { IProfileApplicationContainerTabs } from 'RtUi/components/containers/TabbedApplicationContainer';
import { RtAdminRouter } from '../rtAdmin.router';
import { RtAdmApiRoutes } from 'RtExports/routes';

export class Pm2RouterClass extends RtAdminRouter<void, void, {}> {
	constructor() {
		super('PM2 Processes', 'Pm2', undefined, {});

		this.setPermissionsFromApiRoute(RtAdmApiRoutes.Pm2);
	}

	public getProfileLabel(profile: void): string {
		return '';
	}
}

export const Pm2Router = new Pm2RouterClass();
